export const uk = {
    emptyPrice: 'не задана'
};
